import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CATEGORY_LABEL = {
    hotel: "Hotel",
    camping: "Camping",
    hostal: "Hostal",
    apartamento: "Apartamento",
    otro: "Otro",
};

export default function FeaturedMembers({ members = [] }) {
    if (!members || members.length === 0) return null;
    return (
        <section
            data-testid="featured-members-section"
            className="bg-[#F8F9FA] border-y border-[#E2E4E9]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                            Socios destacados
                        </div>
                        <h2 className="text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                            Alojamientos que ya son parte de ASATTA.
                        </h2>
                    </div>
                    <Link
                        to="/directorio"
                        data-testid="btn-all-directory"
                        className="inline-flex items-center gap-2 text-sm font-medium text-[#082050] hover:opacity-70"
                    >
                        Ver directorio completo
                        <ArrowRight size={14} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {members.map((m, i) => (
                        <article
                            key={m.id || i}
                            data-testid={`featured-member-${i}`}
                            className="bg-white border border-[#E2E4E9] hover:border-[#082050] transition-colors flex flex-col group"
                        >
                            {m.logo && (
                                <div className="aspect-[16/10] overflow-hidden bg-[#F8F9FA]">
                                    <img
                                        src={m.logo}
                                        alt={m.name}
                                        loading="lazy"
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                            )}
                            <div className="p-6 flex-1 flex flex-col">
                                <div className="text-[10px] uppercase tracking-widest text-[#082050]/60">
                                    {CATEGORY_LABEL[m.category] || m.category}
                                </div>
                                <h3 className="mt-2 text-lg font-semibold text-[#082050] tracking-tight">
                                    {m.name}
                                </h3>
                                {m.description && (
                                    <p className="mt-3 text-sm text-[#4A5568] leading-relaxed line-clamp-3">
                                        {m.description}
                                    </p>
                                )}
                                <div className="mt-4 text-xs text-[#718096]">{m.location}</div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
